import { useState, useRef, useEffect } from 'react';

export const DraggableModal = ({ children, onClose, dataTestId, onKeyDown }) => {
  const [pos, setPos] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const startPos = useRef({ x: 0, y: 0 });

  const handleMouseDown = (e) => {
    if (e.target.closest('button') || e.target.closest('input') || e.target.closest('select')) return;
    setIsDragging(true);
    startPos.current = { x: e.clientX - pos.x, y: e.clientY - pos.y };
  };

  useEffect(() => {
    if (!isDragging) return;
    const handleMouseMove = (e) => {
      setPos({ x: e.clientX - startPos.current.x, y: e.clientY - startPos.current.y });
    };
    const handleMouseUp = () => setIsDragging(false);
    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging]);

  const handleBackdropWheel = (e) => {
    // Find the calendar scroll container and scroll it manually
    const calendar = document.querySelector('.custom-scrollbar');
    if (calendar) {
      calendar.scrollTop += e.deltaY;
    }
  };

  return (
    <div
      data-testid={dataTestId}
      className="fixed inset-0 bg-black/10 z-[100] flex items-center justify-center p-6 animate-in fade-in duration-200"
      onClick={onClose}
      onWheel={handleBackdropWheel}
      onKeyDown={onKeyDown}
    >
      <div
        className="w-full max-w-sm bg-white rounded-none p-6 shadow-2xl border border-zinc-100 flex flex-col gap-4 pointer-events-auto cursor-grab active:cursor-grabbing max-h-[90vh] overflow-y-auto custom-scrollbar-hidden"
        style={{ transform: `translate(${pos.x}px, ${pos.y}px)` }}
        onClick={(e) => e.stopPropagation()}
        onMouseDown={handleMouseDown}
      >
        {children}
      </div>
    </div>
  );
};

export default DraggableModal;
